
import Typography from '@mui/material/Typography';


export const TextDrugPhenytoin = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

Phenytoin is a medication used in the management and treatment of epilepsy, generalized tonic-clonic seizures, complex partial seizures, and status epilepticus. 
It is in the anticonvulsants class of drugs. This activity describes the indications, action, and contraindications for phenytoin as a valuable agent in the treatment of epilepsy.
<br /><br />
Phenytoin is an antiepileptic drug with a narrow therapeutic index and large interpatient pharmacokinetic
variability, partly due to genetic variation in CYP2C9. Furthermore, the variant allele HLA-B*15:02 is associated
with an increased risk of Stevens–Johnson syndrome and toxic epidermal necrolysis in response to phenytoin
treatment. We summarize evidence from the published literature supporting these associations and provide
therapeutic recommendations for the use of phenytoin based on CYP2C9 and/or HLA-B genotypes (updates on
cpicpgx.org).

<br /><br />
The purpose of this guideline is to provide information for the
interpretation of human leukocyte antigen B (HLA-B) and/or
cytochrome P450 2C9 (CYP2C9) genotype test results to guide
use and/or dosing of phenytoin. 
<br /><br />


Sources: <br /><br />
https://www.ncbi.nlm.nih.gov/books/NBK551520/#:~:text=Phenytoin%20is%20a%20medication%20used,the%20anticonvulsants%20class%20of%20drugs.<br />
https://cpicpgx.org/guidelines/guideline-for-phenytoin-and-cyp2c9-and-hla-b/

</Typography>

</div>

)
}